/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ClientSecretDto, RotateSecretResult } from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List a client's secrets (fingerprinted, never raw).
 */
export const adminSecretsGetAdminClientsIdGuidSecrets = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<ClientSecretDto[]>(
    { url: `/admin/clients/${id}/secrets`, method: 'GET', signal },
    options,
  );
};

export const getAdminSecretsGetAdminClientsIdGuidSecretsQueryKey = (id?: string) => {
  return [`/admin/clients/${id}/secrets`] as const;
};

export const getAdminSecretsGetAdminClientsIdGuidSecretsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminSecretsGetAdminClientsIdGuidSecretsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>
  > = ({ signal }) => adminSecretsGetAdminClientsIdGuidSecrets(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminSecretsGetAdminClientsIdGuidSecretsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>
>;
export type AdminSecretsGetAdminClientsIdGuidSecretsQueryError = unknown;

export function useAdminSecretsGetAdminClientsIdGuidSecrets<
  TData = Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
          TError,
          Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSecretsGetAdminClientsIdGuidSecrets<
  TData = Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
          TError,
          Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSecretsGetAdminClientsIdGuidSecrets<
  TData = Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a client's secrets (fingerprinted, never raw).
 */

export function useAdminSecretsGetAdminClientsIdGuidSecrets<
  TData = Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminSecretsGetAdminClientsIdGuidSecrets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminSecretsGetAdminClientsIdGuidSecretsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generate a new secret; returned in plaintext ONCE.
 */
export const adminSecretsPostAdminClientsIdGuidSecretsRotate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<RotateSecretResult>(
    { url: `/admin/clients/${id}/secrets/rotate`, method: 'POST', signal },
    options,
  );
};

export const getAdminSecretsPostAdminClientsIdGuidSecretsRotateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSecretsPostAdminClientsIdGuidSecretsRotate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSecretsPostAdminClientsIdGuidSecretsRotate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSecretsPostAdminClientsIdGuidSecretsRotate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSecretsPostAdminClientsIdGuidSecretsRotate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminSecretsPostAdminClientsIdGuidSecretsRotate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSecretsPostAdminClientsIdGuidSecretsRotateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSecretsPostAdminClientsIdGuidSecretsRotate>>
>;

export type AdminSecretsPostAdminClientsIdGuidSecretsRotateMutationError = unknown;

/**
 * @summary Generate a new secret; returned in plaintext ONCE.
 */
export const useAdminSecretsPostAdminClientsIdGuidSecretsRotate = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSecretsPostAdminClientsIdGuidSecretsRotate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminSecretsPostAdminClientsIdGuidSecretsRotate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getAdminSecretsPostAdminClientsIdGuidSecretsRotateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Revoke an individual secret without rotating.
 */
export const adminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid = (
  id: string,
  secretId: string,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<void>(
    { url: `/admin/clients/${id}/secrets/${secretId}`, method: 'DELETE' },
    options,
  );
};

export const getAdminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuidMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid>>,
    TError,
    { id: string; secretId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid>>,
  TError,
  { id: string; secretId: string },
  TContext
> => {
  const mutationKey = ['adminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid>>,
    { id: string; secretId: string }
  > = (props) => {
    const { id, secretId } = props ?? {};

    return adminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid(id, secretId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid>>
>;

export type AdminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuidMutationError = unknown;

/**
 * @summary Revoke an individual secret without rotating.
 */
export const useAdminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid>>,
      TError,
      { id: string; secretId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuid>>,
  TError,
  { id: string; secretId: string },
  TContext
> => {
  const mutationOptions =
    getAdminSecretsDeleteAdminClientsIdGuidSecretsSecretIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
